import 'bootstrap'
import 'babel-polyfill';
import './download'
import './lead'

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import 'slick-carousel';

(function ($) {

    $(document).ready(function () {
        // $('.top-menu .first > .menu-item-container > a').on('mouseenter', function () {
        //   $('.top-menu .first > .menu-item-container').removeClass('open');
        //   $(this).parent().addClass('open');
        // });

        // $('.main').on('mouseenter', function () {
        //   $('.top-menu .first > .menu-item-container').removeClass('open');
        // });

        $('#menu-toggle').on('click', function () {
            $(this).toggleClass('sidemenu-open');
            $('#side-menu').toggleClass('sidemenu-open');
        });

        $('.arrow').on('click', function () {
            $(this).toggleClass('sidemenu-open');
            $(this).siblings('.second').toggleClass('sidemenu-open');
        });

        $('section.press .load-more').on('click', function () {
            $('section.press input[name="pa"]').val(Number($('section.press input[name="pa"]').val()) + 1);
            $(this).closest('form').submit();
        });

        $('section.press select').on('change', function () {
            $('section.press input[name="pa"]').val('');
            $(this).closest('form').submit();
        });

        $('section.press input[name="se"]').on('change', function () {
            $('section.press input[name="pa"]').val('');
            $(this).closest('form').submit();
        });

        $('section.press input[name="re"]').on('change', function () {
            $('section.press input[name="pa"]').val('');
            $(this).closest('form').submit();
        });

        $('section.reports .load-more').on('click', function () {
            $('section.reports input[name="pa"]').val(Number($('section.reports input[name="pa"]').val()) + 1);
            $(this).closest('form').submit();
        });

        $('section.reports select').on('change', function () {
            $('section.reports input[name="pa"]').val('');
            $(this).closest('form').submit();
        });

        $('section.reports input[name="se"]').on('change', function () {
            $('section.reports input[name="pa"]').val('');
            $(this).closest('form').submit();
        });


        // top menu
		let isMouseInsideOpenElement = false;

		$('.top-menu nav .menu-item-container > a').on('mouseover', function(e) {

			const header = $('.header-container')

			const topHeader = header.find('.top-menu')
			
			const dropDownBg = header.find('.second-links')

			const topHeaderHeight = topHeader.outerHeight()

			const hasChildrenLink = $(this).parents('.menu-container.second').length > 0

			if( ! hasChildrenLink &&  ! ( $(this).hasClass('linkedin') || $(this).hasClass('language'))  ) {

				e.preventDefault()

				const nav = $(this).closest('nav')

				const siblingSubmenu = $(this).siblings('.menu-container.second')

				if( siblingSubmenu.length === 0 ) return 

				let maxHeight = 0  

				siblingSubmenu.each( function( index, el ) {

					var height = $(el).outerHeight()

					if (height > maxHeight) {
						maxHeight = height;
					}

				} )


				const paddingExtra = 0; // 2rem
				
				let newHeight = maxHeight + topHeaderHeight + paddingExtra - 80

				if( ! siblingSubmenu.hasClass('open') ) {
					nav.find('.menu-container.second').removeClass('open')
					header.removeClass('open')
				} else {
					newHeight = topHeaderHeight
				}

				header.addClass('open')

				siblingSubmenu.addClass('open')

				if(newHeight > 82) {
					dropDownBg.height( newHeight )
				}

				// Track mouse enter and leave for siblingSubmenu
				siblingSubmenu.on('mouseenter', function() {
					isMouseInsideOpenElement = true
				}).on('mouseleave', function() {
					isMouseInsideOpenElement = false
					setTimeout(function() {
						if (!isMouseInsideOpenElement) {
							siblingSubmenu.removeClass('open')
							header.removeClass('open')
						}
					}, 100);
				});
				
				// Track mouse enter and leave for sibling menu background
				$(document).find('.second-links').on('mouseenter', function() {
					isMouseInsideOpenElement = true
				}).on('mouseleave', function() {
					isMouseInsideOpenElement = false
					setTimeout(function() {
						if (!isMouseInsideOpenElement) {
							siblingSubmenu.removeClass('open')
							header.removeClass('open')
						}
					}, 100);
				});
	
				// Track mouse enter and leave for the link
				$(this).on('mouseenter', function() {
					isMouseInsideOpenElement = true
				}).on('mouseleave', function() {
					isMouseInsideOpenElement = false
					setTimeout(function() {
						if (!isMouseInsideOpenElement) {
							siblingSubmenu.removeClass('open')
							header.removeClass('open')
						}
					}, 100)
				});

			}

		})

		$(document).find('.header-container').on('mouseleave', function(e) {
			$(this).removeClass('open')
			$(this).find('.menu-container.second').removeClass('open')
		})
	});

    $('section.companies .slider').slick({
        arrows: true,
        centerPadding: '60px',
        infinite: false,
        rows: 0,
        slidesToScroll: 1,
        slidesToShow: 4,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1680,
                settings: {
                    centerPadding: '60px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    centerPadding: '40px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }
        ]
    });

	$('.image-with-text__slider').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: true,
        dots: true,
		arrows: false,
		autoplay: false,
		speed: 750,
		fade: true,
		cssEase: 'linear',
	});

	$('.hero__slider').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: true,
        dots: false,
		arrows: false,
		autoplay: true,
		speed: 750,
		fade: true,
		cssEase: 'linear',
	});

    // Hide top menu on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 10;
    var height = 200;

    // Check scroll position
    if ($(window).scrollTop() > height) {
        $('body').removeClass('front-page');
    }

    $(window).scroll(function (event) {
        didScroll = true;
        let scrollTop = $(window).scrollTop();

        if (scrollTop >= 100) {
            $('body').addClass('is-scrolling');
        } else {
            $('body').removeClass('is-scrolling');
        }

    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(window).scrollTop();




        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) {
            return;
        }

        // If they scrolled down and are past the set height, add hide class.
        if (st > lastScrollTop && st > height) {
            // Scroll down
            $('body').addClass('scroll-down');
            $('body').removeClass('front-page');
            // $('.top-menu .menu-container.first').addClass('hide');
        } else {
            // Scroll up
            if (st < height) {
                $('body.home').addClass('front-page');
                $('body').removeClass('scroll-down');
            }

            if (st + $(window).height() < $(document).height()) {
                $('body').removeClass('scroll-down');
                // $('.top-menu .menu-container.first').removeClass('hide');
            }
        }

        lastScrollTop = st;
    }

    function download(url) {
        // Create an invisible download element
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.setAttribute('download', '');
        document.body.appendChild(a);

        // Trigger download
        a.click();

        // Cleanup
        document.body.removeChild(a);
    }


    function convertRemToPixels(rem) {    
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }

})(jQuery)

